import React, { ReactElement } from "react";
import Circle from "../Circle/Circle";
import { MessageSquare } from "react-feather";
import styles from "./Alert.module.css";

interface AlertProps {
  /**
   * Background color of the alert
   */
  color?: "red" | "blue";
  /**
   *  Size of font
   */
  fontSize?: "lg" | "sm" | "md";
  /**
   * Title to display
   */
  title?: string;
  /**
   * Body text to display
   */
  message: string | string[];
}


const Alert: React.FC<AlertProps> = ({
  color = "blue",
  fontSize,
  title,
  message,
  ...rest
}): ReactElement => {
  const getColour = (color: string | undefined, item: string): any => {
    switch (color) {
      case "red":
        if (item === "alert") {
          return `${styles.red}`;
        } else if (item === "circle") {
          return { circleColor: "#A40000", iconColor: "#fdf0f0" };
        }
        break;
      case "blue":
        if (item === "alert") {
          return `${styles.blue}`;
        } else if (item === "circle") {
          return { circleColor: "#37519d", iconColor: "#f2faff" };
        }
        break;
      default:
        if (item === "alert") {
          return `${styles.blue}`;
        } else if (item === "circle") {
          return { circleColor: "#37519d", iconColor: "#f2faff" };
        }
    }
  };

  const getSize = (fontSize: string | undefined) => {
    switch (fontSize) {
      case "lg":
        return styles["font-lg"];
      case "md":
        return styles["font-md"];
      case "sm":
        return styles["font-sm"];
      default:
        return styles["font-sm"];
    }
  };

  const colorClass = getColour(color, "alert");
  const iconColors = getColour(color, "circle");

  let formattedMessage = message;
  if (message?.includes("\n") && typeof message === "string") {
    formattedMessage = message.split("\n");
  }

  return (
    <div className={`${styles.form_alert} ${colorClass} ${getSize(fontSize)}`} {...rest}>
      <Circle color={iconColors.circleColor} size={24}>
        {color === "red" ? (
          <span className={styles.icon_text}>!</span>
        ) : (
          <MessageSquare
            color={iconColors.iconColor}
            size={16}
            style={{
              transform: "scaleX(-1)",
            }}
          />
        )}
      </Circle>
      <div className={styles.text}>
        <h3>{title}</h3>
        {typeof formattedMessage === "string" ? (
          <span>{message}</span>
        ) : (
          formattedMessage?.map((line, index) => {
            return (
              <p key={index} style={{ marginBottom: "1em" }}>
                {line}
              </p>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Alert;
